'use strict';

var Transitionable = require('../Events/Transitionable');

/*
    Typically used to display a little text message in a box in the corner
    of the screen, similar to Gmail's old-school red box that said "Loading...".

    @param notificationArea The ID of the element to be used as the notification area.
    @param message
    @param type
 */
var SimpleLoadingMessage = function(notificationArea, message, type) {
    this.initialize(notificationArea, message, type);
};

jQuery.extend(SimpleLoadingMessage.prototype, Transitionable, {
    DEFAULT_CLASS_NAME: 'generic',
    CLASS_SUFFIX: 'LoadingMessage', 

    parentNode: null,
    loadingDiv: null,
    message: null,
    className: null,
    delay: null,

    initialize: function(notificationArea, message, type){
        var notificationAreaElement = document.getElementById(notificationArea);

        this.parentNode = notificationAreaElement.getElementsByClassName('notificationArea')[0];
        if(!this.parentNode){
            this.parentNode = document.createElement('div');
            this.parentNode.className = 'notificationArea';
            notificationAreaElement.appendChild(this.parentNode);
        }

        this.message = message;
        this.className = (type ? type : this.DEFAULT_CLASS_NAME) + this.CLASS_SUFFIX;
    },

    /*
      Implementing: Transitionable
    */
    enterTransition: function(){
        if(this.delay){
            setTimeout(this._showMessage.bind(this), this.delay);
        } else {
            this._showMessage();
        }
    },

    exitTransition: function(){
        try {
            if(this.loadingDiv){
                var _this = this;
                var onComplete = function () {
                    _this.parentNode.removeChild(_this.loadingDiv);
                    _this.loadingDiv = null;
                };

                jQuery(this.loadingDiv).fadeOut(400, onComplete);
            }
        } catch (e) {
        }
    },

    getElement: function(){
        return this.loadingDiv;
    },

    setExitParticipant: function(obj){
        // Do nothing
    },

    setDelay: function(delay){
        this.delay = delay;
    },

    /**
      * @member SimpleLoadingMessage
      */
    toString: function(){
        return '[MITS.Widgets.SimpleLoadingMessage]: ' + this.element;
    },

    /*
        Protected Methods
    */
    _showMessage: function () {
        try {
            if (!this.loadingDiv) {
                this._generateElements();
                jQuery(this.loadingDiv).fadeIn(400);
                MITS.UI.Util.applyHighlightEffect(this.loadingDiv.id);
            }
        } catch (e) {
        }
    },

    _generateElements: function(){
        this.loadingDiv = document.createElement('div');
        this.loadingDiv.id = 'loadingDiv';
        this.loadingDiv.innerHTML = this.message;
        this.loadingDiv.className = this.className;
        this.loadingDiv.style.display = 'none';
        this.parentNode.appendChild(this.loadingDiv);
    }
});

module.exports = SimpleLoadingMessage;



//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/SimpleLoadingMessage.js
// module id = 39
// module chunks = 0